import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'am-toast',
  templateUrl: './am-toast.component.html',
  styleUrls: ['./am-toast.component.scss'],
  standalone: false,
})
export class AmToastComponent implements OnChanges, OnDestroy {
  @Input() message: string = '';
  @Input() type: 'success' | 'error' | 'info' = 'success';
  @Input() duration: number = 3000;
  @Input() isVisible: boolean = false;

  @Output() onDismiss = new EventEmitter<void>();

  /** Controls the CSS animation state */
  showToast: boolean = false;
  dismissing: boolean = false;

  private _timeoutId: ReturnType<typeof setTimeout> | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isVisible'] && changes['isVisible'].currentValue === true) {
      this.show();
    }
  }

  ngOnDestroy(): void {
    this.clearTimeout();
  }

  private show(): void {
    this.clearTimeout();
    this.dismissing = false;
    this.showToast = true;

    this._timeoutId = setTimeout(() => {
      this.dismiss();
    }, this.duration);
  }

  private dismiss(): void {
    this.dismissing = true;

    // Wait for fade-out animation to complete before hiding
    setTimeout(() => {
      this.showToast = false;
      this.dismissing = false;
      this.onDismiss.emit();
    }, 300);
  }

  private clearTimeout(): void {
    if (this._timeoutId !== null) {
      clearTimeout(this._timeoutId);
      this._timeoutId = null;
    }
  }
}
